// Fetch city data
// document.addEventListener("DOMContentLoaded", function () {
//   const csvUrl = "https://cdn.shopify.com/s/files/1/0920/1041/4387/files/cities.csv?v=1740997059";
//   const citySelect = document.getElementById("ContactForm-city");

//   fetch(csvUrl)
//     .then(response => response.text())
//     .then(data => {
//       const rows = data.split("\n").map(row => row.trim()).filter(row => row); 
//       const headers = rows[0].split(",").map(header => header.replace(/"/g, "").trim().toLowerCase());     
//       const nameIndex = headers.indexOf("name");
//       if (nameIndex === -1) {
//         console.error("Column 'name' not found in CSV. Available headers:", headers);
//         return;
//       }
//       rows.slice(1).forEach(row => {
//         const columns = row.split(",").map(col => col.replace(/"/g, "").trim());
//         const city = columns[nameIndex];

//         if (city) {
//           const option = document.createElement("option");
//           option.value = city;
//           option.textContent = city;
//           citySelect.appendChild(option);
//         }
//       });
//     })
//     .catch(error => console.error("Error fetching CSV:", error));
// });
// city data for text-field
  document.addEventListener("DOMContentLoaded", function () {
    const csvUrl = "https://cdn.shopify.com/s/files/1/0920/1041/4387/files/cities.csv?v=1740997059";
    const input = document.getElementById("ContactForm-city");
    const suggestionList = document.getElementById("citySuggestions");
    let cities = [];

    // Load cities from CSV
    fetch(csvUrl)
      .then(res => res.text())
      .then(data => {
        const rows = data.split("\n").map(r => r.trim()).filter(r => r);
        const headers = rows[0].split(",").map(h => h.toLowerCase().replace(/"/g, ""));
        const nameIndex = headers.indexOf("name");

        if (nameIndex === -1) return;

        cities = rows.slice(1).map(row => {
          const cols = row.split(",").map(c => c.replace(/"/g, "").trim());
          return cols[nameIndex];
        }).filter(Boolean);
      });

    input.addEventListener("input", function () {
      const value = input.value.toLowerCase();
      suggestionList.innerHTML = "";

      if (value.length === 0) return;

      const filtered = cities.filter(city => city.toLowerCase().startsWith(value)).slice(0, 10);


      filtered.forEach(city => {
        const li = document.createElement("li");
        li.textContent = city;
        li.addEventListener("click", () => {
          input.value = city;
          suggestionList.innerHTML = "";
        });
        suggestionList.appendChild(li);
      });
    });

    // Hide suggestions on outside click
    document.addEventListener("click", (e) => {
      if (!e.target.closest(".field")) {
        suggestionList.innerHTML = "";
      }
    });
  });
// city data for text-field



// 
$(document).ready(function () {
     function validateForm(form) {
        let isValid = true;
        form.find(".error-message").remove();
        function showError(input, message) {
            input.after('<p class="error-message" style="color:red;">' + message + "</p>");
        }

        let name = form.find("#ContactForm-name").val()?.trim();
        let email = form.find("#ContactForm-email").val()?.trim();
        let city = form.find("#ContactForm-city").val()?.trim();
        let phone = form.find("#ContactForm-phone").val()?.trim();
        // let course = form.find("#ContactForm-course").val();
        let remark = form.find("#ContactForm-remark").val()?.trim();
        
        if (!name) {
            isValid = false;
            showError(form.find("#ContactForm-name"), "Name is required");
        }
        let emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!email || !emailPattern.test(email)) {
            isValid = false;
            showError(form.find("#ContactForm-email"), "Enter a valid email");
        }
        if (!city) {
            isValid = false;
            showError(form.find("#ContactForm-city"), "City is required");
        }
        let phonePattern = /^[0-9]{10,}$/;
        if (!phone || !phonePattern.test(phone)) {
            isValid = false;
            showError(form.find("#ContactForm-phone"), "Enter a valid phone number");
        }
        // if (!course || course === "Choose a Course") {
        //     isValid = false;
        //     showError(form.find("#ContactForm-course"), "Please select a course");
        // }
        if (!remark) {
          isValid = false;
          showError(form.find("#ContactForm-remark"), "Remark is required");
        }
        return isValid;
    }
    $("#EnquiryForm").submit(function (event) {
     event.preventDefault();
    
      let form = $(this);
      if (!validateForm(form)) return;
    
      // Check if success message already exists
      if (form.find(".success-message").length === 0) {
        var successMessage = $('<div class="success-message">Your form has been submitted successfully!</div>');
      }
    
      let formData = {
        name: form.find("#ContactForm-name").val()?.trim(),
        email: form.find("#ContactForm-email").val()?.trim(),
        contact_no: form.find("#ContactForm-phone").val()?.trim(),
        city: form.find("#ContactForm-city").val()?.trim(),
        remarks: form.find("#ContactForm-remark").val()?.trim(),
      };
    
      $.ajax({
        url: "https://mobile.acharyavikulbansal.com/api/v1/lead-generate",
        type: "POST",
        contentType: "application/json",
        data: JSON.stringify(formData),
        success: function (response) {
          // Only append if not already present
          if (successMessage && form.find(".success-message").length === 0) {
            form.append(successMessage);
          }
    
          setTimeout(function () {
            form[0].reset();
            successMessage.remove();
          }, 3000);
        },
        error: function (error) {
          alert("Error submitting form. Please try again.");
          console.error("Submission error:", error);
        }
      });
    });
     $("#EnquiryForm input, #EnquiryForm select").on("input change", function () {
        $(this).next(".error-message").remove();
    });
  });
    var swiper = new Swiper(".howItWorks", {
      slidesPerView: 1.1,
      spaceBetween: 16,
      breakpoints: {
        375: {
          slidesPerView: 1.5,
          spaceBetween: 16,
        },
        640: {
          slidesPerView: 2.5,
          spaceBetween: 16,
        },
        768: {
          slidesPerView:3 ,
          spaceBetween: 16,
        },
        1024: {
          slidesPerView: 3,
        },
      },
    });